module.exports = __webpack_public_path__ + "assets/img/xiulizhan-8660abf4.png";